const getFilters = () => (
  {
    aktuell: sessionStorage.getItem('aktuell') || 0,
    nutzerfreundlich: sessionStorage.getItem('nutzerfreundlich') || 0,
    vertrauenswuerdig: sessionStorage.getItem('vertrauenswuerdig') || 0,
    verstaendlich: sessionStorage.getItem('verstaendlich') || 0,
  }
)

export { getFilters };